<template>
    <el-dialog title="采购编辑" :visible.sync="dialogOutVisible" width="50%">
        <el-row type="flex" align="middle" v-if="Object.keys(infoData).length">
            <el-col :span="4">
                <el-image
                    v-if="infoData.imagesList != null"
                    style="width: 100%; height: 100%;"
                    :src="infoData.imagesList[0]"
                    :preview-src-list="infoData.imagesList"
                ></el-image>
                <div v-else>
                    暂无图片
                </div>
            </el-col>
            <el-col :span="18" :offset="2">
                <div class="inform flex">
                    <div class="title">商品全称：</div>
                    <div>{{ infoData.productFullName }}</div>
                </div>
                <div class="inform flex">
                    <div class="title">商品简称：</div>
                    <div>{{ infoData.productSimpleName }}</div>
                </div>
                <div class="inform flex">
                    <div class="title">商品描述：</div>
                    <div>{{ infoData.productDescription }}</div>
                </div>
                <div class="inform flex">
                    <div class="title">库存编号：</div>
                    <div>{{ infoData.inventoryNumber }}</div>
                </div>

                <el-row type="flex" justify="space-between">
                    <div class="inform flex">
                        <div class="title">申请库存数量：</div>
                        <div>{{ infoData.predictCount }}</div>
                    </div>
                    <el-button type="primary" @click="visibleProductLink">查看货源</el-button>
                </el-row>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="padding" type="flex" justify="space-between" align="middle">
            <div>
                <div v-if="this.infoData.purchaseNumber">采购单据号：{{ this.infoData.purchaseNumber }}</div>
            </div>
            <div>
                <el-button type="primary" @click="isEdit = false" v-show="isEdit">编辑</el-button>
                <el-button type="success" @click="isEdit = true" v-show="!isEdit">确认</el-button>
            </div>
        </el-row>
            <el-col :span="25">
                <el-row>
                <el-col class="padding" :span="20">
                    <el-input v-model="formData.purchaseModel" :disabled="isEdit">
                        <template slot="prepend">
                                <el-tooltip content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对" placement="top">
                                    <el-button>海逊仓库核对详情:</el-button>
                                </el-tooltip>
                        </template>
                    </el-input>
                </el-col>          
                </el-row>

                <el-row  :gutter="20">
                    <el-col class="padding" :span="5">
                        <el-input v-model="formData.purchasePrice" :disabled="isEdit">
                            <template slot="prepend">采购单价:</template>
                        </el-input>
                    </el-col>

                    <el-col class="padding" :span="5">
                        <el-input v-model="formData.rebatePrice" :disabled="isEdit">
                            <template slot="prepend">返佣:</template>
                        </el-input>
                    </el-col>

                    <el-col class="padding" :span="5">
                        <el-input v-model="formData.otherPrice" :disabled="isEdit">
                            <template slot="prepend">其它费用:</template>
                        </el-input>
                    </el-col>
                    
                    <!-- <el-form-item label="其它费用备注"></el-form-item> -->
                    <el-col class="padding" :span="5">
                        <span class="leix">类型:</span>
                        <el-select v-model="formData.purchaseTypeCode" style="width: 75%;" class="logistics" :disabled="isEdit">
                            <el-option
                                v-for="item in listType"
                                :key="item.id"
                                :label="item.itemTypeName"
                                :value="item.itemTypeName"
                            ></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col class="padding" :span="5">
                        <span class="leix">物流公司:</span>
                        <el-select v-model="formData.logisticsCompany" filterable placeholder="请选择" style="width: 59%;" class="logistics" :disabled="isEdit" clearable @change="SelectTrack17Logistics" value-key="id">
                            <el-option
                                v-for="item in Track17Logistics"
                                :key="item.id"
                                :label="item.nameCn"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col class="padding" :span="15">
                        <el-input v-model.trim="formData.internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')" :disabled="isEdit">
                            <template slot="prepend">运单号码:</template>
                        </el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="padding" :span="20">
                        <el-input v-model="formData.remark" :disabled="isEdit">
                            <template slot="prepend">采购备注:</template>
                        </el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="padding" :span="10">  
                        <span class="leix">采购数量:</span>
                        <el-input-number class="logistics" v-model="formData.purchaseQuantity" :disabled="isEdit" :min="1" size="small"></el-input-number>
                        <!-- <el-input v-model="formData.purchaseQuantity" :disabled="isEdit">
                            <template slot="prepend">采购数量:</template>
                        </el-input> -->
                    </el-col>
                </el-row>
            </el-col>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogOutVisible = false">取 消</el-button>
            <el-button type="primary" @click="addFormData" :loading="isLoading">提 交</el-button>
        </div>
        <el-dialog title="货源链接" :visible.sync="dialogInnerVisible" append-to-body width="35%">
            <el-form>
                <el-form-item label>
                    <el-row type="flex" align="middle" v-for="(item, index) in productLinkList" :key="item.id">
                        <el-col :span="18">
                            <el-input
                                placeholder="请输入内容"
                                v-model="item.value"
                                style="margin-right:10px"
                            ></el-input>
                        </el-col>
                        <el-button type="primary" @click="openLink(item.value)">访问链接</el-button>
                        <el-button
                            type="danger"
                            @click="edit_blue_del(index)"
                            icon="el-icon-close"
                            v-show="productLinkList.length > 1"
                        ></el-button>
                    </el-row>
                    <span style="color:#F56C6C">此链接记录货源链接，可填写1-5条，非必填。</span>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit_blue_point">增加一条记录</el-button>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogInnerVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProductLink" :loading="loading === 'dialogInnerVisible'">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import { Baseurl, ajaxPost } from "@/api/api/api";

export default {
    name: "Stockpurchaseedit",

    data() {
        return {
            dialogOutVisible: false,
            infoData: {},
            logisticsCompany: '',
            companyCode: '',
            formData: {
                internalConveyNumber: "",
                purchasePrice: "",
                rebatePrice: "",
                logisticsCompany: "",
                purchaseTypeCode: "",
                remark: "",
                otherPrice: "",
                purchaseModel: "",
                purchaseQuantity: "",
            },
            listType: [],
            isEdit: true,
            dialogInnerVisible: false,
            productLinkList: [],
            loading: "",
            Logistics:[],
            Track17Logistics: [],
            isLoading:false,
            str:""
        };
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
    },
    methods: {
        init(row) {
            this.loading = "";
            this.dialogOutVisible = true;
            this.infoData = row;
            this.getListType();
            let {
                internalConveyNumber,
                purchasePrice1: purchasePrice,
                rebatePrice,
                logisticsCompany,
                purchaseTypeCode,
                remark,
                otherPrice,
                purchaseModel,
                purchaseQuantity,
            } = row;
            if(!purchaseQuantity){
                purchaseQuantity = row.predictCount;
            }
            this.formData = {
                internalConveyNumber,
                purchasePrice,
                rebatePrice,
                logisticsCompany,
                purchaseTypeCode,
                remark,
                otherPrice,
                purchaseModel,
                purchaseQuantity,
            };
            // this.formData.internalConveyNumber;
            this.getLogisticsList()
            this.Track17LogisticsAjax()
        },
        close() {
            this.dialogOutVisible = false;
            this.loading = "";
            this.formData = {
                internalConveyNumber: "",
                purchasePrice: "",
                rebatePrice: "",
                logisticsCompany: "",
                purchaseTypeCode: "",
                remark: "",
                otherPrice: "",
                purchaseModel: "",
            };
        },
        getListType() {
            if (this.listType.length) return;
            const API = Baseurl + "purchaseController/selectItemList";
            const paramsData = {
                itemCode: "HYXUN0000001",
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listType = data;
                }
            });
        },
        addFormData() {
            if (!this.isEdit) {
                this.$message.warning("请先确认填写完毕");
                return;
            }
            // console.log(this.infoData)
            const paramsData = {
                inventoryNo: this.infoData.inventoryNumber,
                inventoryId: this.infoData.id,
                inventoryBatchNo:this.infoData.inventoryBatchNo,
                id: this.infoData.purchaseId,
                ...this.formData,
                logisticsCompany: this.logisticsCompany,
                companyCode: this.companyCode
            };
            // console.log(paramsData);
            // return;
            this.isLoading = true
            this.$emit("confirm", paramsData);
            this.isLoading = false
        },
        visibleProductLink() {
            this.productLinkList = this.infoData.productLinkList.map((item, index) => ({ id: index, value: item }));
            this.dialogInnerVisible = true;
        },
        edit_blue_point() {
            if (this.productLinkList.length === 5) return;
            this.productLinkList.push({ id: this.productLinkList.length + 1, value: "" });
        },
        edit_blue_del(index) {
            this.productLinkList.splice(index, 1);
        },
        async addProductLink() {
            if (!this.productLinkList.length) return;
            this.loading = "dialogInnerVisible";
            const API = Baseurl + "inventoryController/updateInventoryById";
            const productLinkList = this.productLinkList.map(item => item.value);
            const paramsData = {
                id: this.infoData.id,
                roleId:this.str.rid,
                productLinkList,
            };
            const {
                data: { code, data },
            } = await ajaxPost(API, paramsData);
            this.loading = "";
            if (code === 200) {
                this.dialogInnerVisible = false;
                this.infoData.productLinkList = productLinkList;
                this.$message.success("操作成功");
            } else {
                this.$message.error("操作失败");
            }
        },
        openLink(path) {
            if (!path) return;
            window.open(path);
        },
        getLogisticsList() {
            const API = Baseurl + 'logisticsController/getLogisticsCompanyList'
            ajaxPost(API).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.Logistics = data
                }
            })
        },
        Track17LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getTrack17Carriers'
			).then((res) => {
				if (res.data.code == 200) {
					this.Track17Logistics = res.data.data
				}
			})
		},
        SelectTrack17Logistics(val) {
			// console.log(val)
            if(val) {
                this.logisticsCompany = val.nameCn
                this.companyCode = val.key
            }
		},
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-dialog__body {
        padding: 13px 20px;
    }
    .el-input-group__append,
    .el-input-group__prepend {
        padding: 0 10px !important;
    }
    .logistics .el-input__inner{
    border-radius: 0px 4px 4px 0px!important;
 }
}
.line-height {
    line-height: 35px;
}
.padding {
    padding: 10px 0;
}
img {
    width: 100%;
    height: 100%;
}
.leix {
    background-color: #f5f7fa;
    line-height: 30px;
    padding: 5px;
    border-left: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
    border-top: 1px solid #e4e7ed;
    color: #909399;
    border-radius: 4px 0px 0px 4px;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
</style>
